"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAvatar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/avatar/avatar");
const dot_styles_1 = require("@/components/common/dot/dot.styles");
require("@/components/common/dot/semantics/status-dot");
const utils_1 = require("@/utils");
/** 접속 점은 아바타가 클수록 커지며, 점이 정한 크기 단계 안에서 고른다. */
const presenceDotSizes = {
    '80': '16',
    '48': '12',
    '40': '8',
    '32': '8',
};
const presenceDotSizeTokens = Object.fromEntries(Object.entries(presenceDotSizes).map(([avatarSize, dotSize]) => [
    avatarSize,
    { '--dot-size': dot_styles_1.dotSizes[dotSize] },
]));
let UserAvatar = class UserAvatar extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.size = '40';
        this.online = false;
        this.ariaLabel = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-avatar
        shape="circle"
        size=${this.size}
        src=${(0, if_defined_js_1.ifDefined)(this.src)}
        aria-label=${this.ariaLabel}
      >
        ${this.renderInitials()}
      </mm-avatar>
      ${this.renderPresence()}
    `;
    }
    renderInitials() {
        if (!this.initials)
            return lit_1.nothing;
        return this.initials;
    }
    renderPresence() {
        if (!this.online)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-status-dot variant="online"></mm-status-dot>
    `;
    }
    /** 사람 이름의 앞 글자. 공백으로 나뉘면 두 단어까지 딴다. */
    get initials() {
        const words = this.name.trim().split(/\s+/).filter(Boolean);
        if (!words.length)
            return '';
        return words
            .slice(0, 2)
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase();
    }
};
UserAvatar.styles = (0, lit_1.css) `
    /* 겹쳐 놓을 때 소비자가 host에 두르는 ring이 아바타의 원을 따라가게 한다. */
    :host {
      display: inline-flex;
      flex-shrink: 0;
      width: fit-content;
      height: fit-content;
      border-radius: var(--radius-full);
      position: relative;
    }

    /* 원의 45° 지점에 점의 중심을 얹는다. 모서리에서 반지름의 29.3%가 그 지점이다. */
    mm-status-dot {
      outline: calc(var(--border-width) * 2) solid var(--background-color);
      position: absolute;
      inset-inline-end: calc(14.6% - var(--dot-size) / 2);
      inset-block-end: calc(14.6% - var(--dot-size) / 2);
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', presenceDotSizeTokens, 'mm-status-dot'))}
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserAvatar.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserAvatar.prototype, "src", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], UserAvatar.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], UserAvatar.prototype, "online", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], UserAvatar.prototype, "ariaLabel", void 0);
UserAvatar = __decorate([
    (0, decorators_js_1.customElement)('mm-user-avatar')
], UserAvatar);
exports.UserAvatar = UserAvatar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1hdmF0YXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1c2VyLWF2YXRhci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBK0Q7QUFDL0QscURBQTJEO0FBQzNELGdFQUF3RDtBQUl4RCw2Q0FBMEM7QUFDMUMsbUVBQTJFO0FBQzNFLHdEQUFxRDtBQUNyRCxtQ0FBNkM7QUFFN0MsK0NBQStDO0FBQy9DLE1BQU0sZ0JBQWdCLEdBQUc7SUFDdkIsSUFBSSxFQUFFLElBQUk7SUFDVixJQUFJLEVBQUUsSUFBSTtJQUNWLElBQUksRUFBRSxHQUFHO0lBQ1QsSUFBSSxFQUFFLEdBQUc7Q0FDcUMsQ0FBQTtBQUVoRCxNQUFNLHFCQUFxQixHQUFHLE1BQU0sQ0FBQyxXQUFXLENBQzlDLE1BQU0sQ0FBQyxPQUFPLENBQUMsZ0JBQWdCLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLFVBQVUsRUFBRSxPQUFPLENBQUMsRUFBRSxFQUFFLENBQUM7SUFDOUQsVUFBVTtJQUNWLEVBQUUsWUFBWSxFQUFFLHFCQUFRLENBQUMsT0FBTyxDQUFDLEVBQUU7Q0FDcEMsQ0FBQyxDQUNILENBQUE7QUFHTSxJQUFNLFVBQVUsR0FBaEIsTUFBTSxVQUFXLFNBQVEsZ0JBQVU7SUFBbkM7O1FBc0J1QixTQUFJLEdBQUcsRUFBRSxDQUFBO1FBRXdCLFNBQUksR0FBZSxJQUFJLENBQUE7UUFDdkQsV0FBTSxHQUFHLEtBQUssQ0FBQTtRQUNVLGNBQVMsR0FBRyxFQUFFLENBQUE7SUF5Q3JFLENBQUM7SUF2Q0MsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7OztlQUdBLElBQUksQ0FBQyxJQUFJO2NBQ1YsSUFBQSx5QkFBUyxFQUFDLElBQUksQ0FBQyxHQUFHLENBQUM7cUJBQ1osSUFBSSxDQUFDLFNBQVM7O1VBRXpCLElBQUksQ0FBQyxjQUFjLEVBQUU7O1FBRXZCLElBQUksQ0FBQyxjQUFjLEVBQUU7S0FDeEIsQ0FBQTtJQUNILENBQUM7SUFFTyxjQUFjO1FBQ3BCLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRWxDLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQTtJQUN0QixDQUFDO0lBRU8sY0FBYztRQUNwQixJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU07WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVoQyxPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDO0lBRUQsdUNBQXVDO0lBQ3ZDLElBQVksUUFBUTtRQUNsQixNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUE7UUFDM0QsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNO1lBQUUsT0FBTyxFQUFFLENBQUE7UUFFNUIsT0FBTyxLQUFLO2FBQ1QsS0FBSyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUM7YUFDWCxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO2FBQzNCLElBQUksQ0FBQyxFQUFFLENBQUM7YUFDUixXQUFXLEVBQUUsQ0FBQTtJQUNsQixDQUFDOztBQWpFTSxpQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O01BbUJmLElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsTUFBTSxFQUFFLHFCQUFxQixFQUFFLGVBQWUsQ0FBQyxDQUFDO0dBQ2pGLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3dDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFhO0FBQ3FCO0lBQTVELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQUM7d0NBQXdCO0FBQ3ZEO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzswQ0FBZTtBQUNVO0lBQXBELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxDQUFDOzZDQUFlO0FBMUJ4RCxVQUFVO0lBRHRCLElBQUEsNkJBQWEsRUFBQyxnQkFBZ0IsQ0FBQztHQUNuQixVQUFVLENBbUV0QjtBQW5FWSxnQ0FBVSJ9